import profileProperties from '@api/graphql/searchStorefrontFragment';

export const bowVendorSearchQuery = `
  query BowVendorSearch (
      $city: String,
      $filters: [String],
      $limit: Int,
      $page: Int,
      $seed: String
      $sort: [SortInput!],
      $state: String,
    ){
      search(
        filters: $filters,
        limit: $limit,
        location: { city: $city, state: $state },
        page: $page,
        seed: $seed,
        sort: $sort,
        fixedPageSize: true
      ) {
        profiles {
          ...ProfileProperties
        }
      }
    }
    ${profileProperties}
`;
